import { api } from './api';
import { companyOverviewSchema, type CompanyOverview } from '@/types/schemas';

export const companyService = {
  overview: (periodId?: string, signal?: AbortSignal): Promise<CompanyOverview> =>
    api.get(
      `/company/overview${periodId ? `?period_id=${periodId}` : ''}`,
      companyOverviewSchema,
      signal,
    ),
};
